import { Component, OnInit, Input } from '@angular/core';
import { ClaimService } from '../claim.service';
import { CrawfordSpinnerService, ITabComponent } from 'crawford-shell';
import { ProgressStageDetails } from '../model/progress-stage-details.model';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-claim-present-position',
  templateUrl: './claim-present-position.component.html',
  styleUrls: ['./claim-present-position.component.scss']
})
export class ClaimPresentPositionComponent implements OnInit, ITabComponent {

  @Input() public show: boolean;
  @Input() public crawfordRef: string;

  public currentPosition: string;
  public progressStageDetails: ProgressStageDetails;
  public spinnerName = 'presentPositionSpinner';

  constructor(
    private claimService: ClaimService,
    private spinnerService: CrawfordSpinnerService
  ) { }

  ngOnInit() {
  }

  loadData(): void {
    if (this.show) {
      this.spinnerService.show(this.spinnerName);

      Observable.zip(
        this.claimService.getPresentPosition(this.crawfordRef),
        this.claimService.getProgressStageDetails(this.crawfordRef)
      ).subscribe(
        results => {
          if (results[0] != null) {
            this.currentPosition = results[0];
          } else {
            this.currentPosition = 'No present position available';
          }

          this.progressStageDetails = results[1];
          this.spinnerService.hide(this.spinnerName);
        },
        error => {
          this.spinnerService.hide(this.spinnerName);
        }
      );
    }
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/claim/claim-present-position/claim-present-position.component.ts